(function () {
  // Prev/next arrows for the thumbnail gallery layouts. Only the .is-active slide
  // is visible there, so the default slider scroll does nothing - step the active
  // media instead.
  function getGallery(button) {
    return button.closest('media-gallery');
  }

  function getOrderedMediaIds(gallery) {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return [];
    // Slide wrappers only - inner zoom/video elements carry data-media-id too.
    return Array.from(viewer.querySelectorAll('.product__media-item[data-media-id]')).map((el) => el.dataset.mediaId);
  }

  function step(gallery, direction, buttonsWrapper) {
    const ids = getOrderedMediaIds(gallery);
    if (ids.length < 2) return;

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const activeEl =
      viewer.querySelector('.product__media-item.is-active[data-media-id]') ||
      viewer.querySelector('.product__media-item[data-media-id]');
    const currentIndex = ids.indexOf(activeEl.dataset.mediaId);
    const nextIndex = (currentIndex + direction + ids.length) % ids.length;

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(ids[nextIndex], false);
    }

    // SliderComponent's resize observer resets the counter and buttons shortly
    // after, so set them again once it has run.
    const applyCount = () => {
      const counter = buttonsWrapper.querySelector('.slider-counter--current');
      if (counter) counter.textContent = nextIndex + 1;
      const prevBtn = buttonsWrapper.querySelector('.slider-button--prev');
      const nextBtn = buttonsWrapper.querySelector('.slider-button--next');
      if (prevBtn) prevBtn.removeAttribute('disabled');
      if (nextBtn) nextBtn.removeAttribute('disabled');
    };
    applyCount();
    setTimeout(applyCount, 60);
  }

  // Capture phase so SliderComponent's own click handler never runs for these buttons.
  document.addEventListener(
    'click',
    (event) => {
      const nextButton = event.target.closest('media-gallery .slider-button--next');
      const prevButton = event.target.closest('media-gallery .slider-button--prev');
      const button = nextButton || prevButton;
      if (!button) return;

      const gallery = getGallery(button);
      const buttonsWrapper = button.closest('.slider-buttons');
      if (!gallery || !buttonsWrapper) return;

      event.stopPropagation();
      step(gallery, nextButton ? 1 : -1, buttonsWrapper);
    },
    true
  );
})();
